var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "cms-action-grid",
    [
      _c(
        "cms-action-button",
        {
          attrs: {
            icon: "magicon-jump-down-left",
            disabled: !_vm.canDeploy || _vm.disabled,
          },
          on: {
            click: function ($event) {
              return _vm.showActionModal("DEPLOY")
            },
          },
        },
        [_vm._v("Inzetten")]
      ),
      _c(
        "cms-action-button",
        {
          attrs: {
            icon: "magicon-jump-up-right",
            disabled: !_vm.canReturn || _vm.disabled,
          },
          on: {
            click: function ($event) {
              return _vm.showActionModal("RETOUR")
            },
          },
        },
        [_vm._v("Retour")]
      ),
      _vm.userIsAdmin
        ? _c(
            "cms-action-button",
            {
              attrs: {
                icon: "magicon-jump-right-up",
                disabled: !_vm.canRelease || _vm.disabled,
              },
              on: {
                click: function ($event) {
                  return _vm.showActionModal("RELEASE")
                },
              },
            },
            [_vm._v("Vrijgeven")]
          )
        : _vm._e(),
      _c(
        "cms-action-button",
        {
          attrs: {
            icon: "entypo-warning",
            disabled: !_vm.canRepairPending || _vm.disabled,
          },
          on: {
            click: function ($event) {
              return _vm.showActionModal("REPAIR_PENDING")
            },
          },
        },
        [_vm._v("Behoeft reparatie")]
      ),
      _vm.userIsAdmin
        ? _c(
            "cms-action-button",
            {
              attrs: {
                icon: "entypo-tools",
                disabled: !_vm.canRepairActive || _vm.disabled,
              },
              on: {
                click: function ($event) {
                  return _vm.showActionModal("REPAIR_ACTIVE")
                },
              },
            },
            [_vm._v("Reparatie aanmaken")]
          )
        : _vm._e(),
      _vm.userIsAdmin
        ? _c(
            "cms-action-button",
            {
              attrs: {
                icon: "entypo-trash",
                disabled: !_vm.canWriteOff || _vm.disabled,
              },
              on: {
                click: function ($event) {
                  return _vm.showActionModal("WRITE_OFF")
                },
              },
            },
            [_vm._v("Afschrijven")]
          )
        : _vm._e(),
      !_vm.actionMode
        ? _c(
            "cms-action-button",
            {
              attrs: {
                icon: "entypo-flag",
                disabled: !_vm.canCreateAction || _vm.disabled,
              },
              on: { click: _vm.createAction },
            },
            [_vm._v("Actie aanmaken")]
          )
        : _vm._e(),
      _c(
        "cms-action-button",
        {
          attrs: {
            icon: "magicon-repeat",
            disabled: !_vm.canReplace || _vm.disabled,
          },
          on: {
            click: function ($event) {
              return _vm.showActionModal("REPLACE")
            },
          },
        },
        [_vm._v("Vervangen")]
      ),
      _vm.userIsAdmin
        ? _c(
            "cms-action-button",
            {
              attrs: {
                icon: "entypo-shuffle",
                disabled: !_vm.canTransfer || _vm.disabled,
              },
              on: {
                click: function ($event) {
                  return _vm.showActionModal("TRANSFER")
                },
              },
            },
            [_vm._v("Overdragen")]
          )
        : _vm._e(),
      _vm.userIsAdmin
        ? _c(
            "cms-action-button",
            {
              attrs: {
                icon: "magicon-clock",
                disabled: !_vm.canChangeActionDeadline || _vm.disabled,
              },
              on: { click: _vm.showChangeActionDeadlineModal },
            },
            [_vm._v("Afhandelingstermijn wijzigen")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }